export default {
  categories: {
    loading: false,
    error: null,
    data: [],
  },
};
